var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player-ws-flv-king-container"},[_c('video',{ref:"myPlayerDom",staticClass:"ws-flv-style",attrs:{"controls":_vm.videoConfig.controls,"autoplay":_vm.videoConfig.autoplay},domProps:{"muted":_vm.videoConfig.muted}})])
}
var staticRenderFns = []

export { render, staticRenderFns }